import { Component, ViewChild, OnInit, OnDestroy } from '@angular/core';

import { AuthorizationService } from '../../../shared/index';

import { ModalDirective } from 'ngx-bootstrap/modal';

@Component({
    selector: 'survey-index',
    templateUrl: './survey-index.html',
    standalone: false
})

export class SurveyIndexComponent implements OnInit, OnDestroy {
    @ViewChild('verifySurveyModal') verifySurveyModal: ModalDirective;

    public verificationRunning = false;


    constructor(
        private _authorizationService: AuthorizationService,
        //private _catalogService: CatalogService
    )
    {


    }

    ngOnInit(): void {

    }

    ngOnDestroy(): void {
        //for (let subscription of this.subscriptions) {
        //    subscription.unsubscribe();
        //}
    }

    public verifySurveys(): void {
        this.verifySurveyModal.show();
    }

    public startVerification(): void {
        this.verificationRunning = true;

    }

    public cancelVerification(): void {
        this.verificationRunning = false;
        this.verifySurveyModal.hide();

    }
}
